<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="계기번호"
            name="valveRuptureNo"
            v-model="searchParam.valveRuptureNo">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="내용물"
            name="inMaterial"
            v-model="searchParam.inMaterial">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-process
            label="관련공정"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="valveRupture"
          title="안전밸브 및 파열판 목록"
          tableId="valveRupture"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="psiValveRuptureId"
          :columnSetting="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="신규" icon="add" @btnClicked="equipmentPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'valve-rupture',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'valveRuptureNo',
            field: 'valveRuptureNo',
            label: '계기번호',
            align: 'center',
            style: 'width:120px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'inMaterial',
            field: 'inMaterial',
            label: '내용물',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'conditionVal',
            field: 'conditionVal',
            label: '상태',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: 'outVolume',
            field: 'outVolume',
            label: '배출용량(kg/hr)',
            align: 'center',
            style: 'width:100px',
            type: 'cost',
            sortable: true,
          },
          {
            name: 'regulVolume',
            field: 'regulVolume',
            label: '정격용량(kg/hr)',
            align: 'center',
            style: 'width:100px',
            type: 'cost',
            sortable: true,
          },
          {
            label: '노즐크기',
            align: 'center',
            child: [
              {
                name: 'nozzleSizeIn',
                field: 'nozzleSizeIn',
                label: '입구',
                align: 'center',
                sortable: true,
                style: 'width:60px',
              },
              {
                name: 'nozzleSizeOut',
                field: 'nozzleSizeOut',
                label: '출구',
                align: 'center',
                sortable: true,
                style: 'width:60px',
              },
            ]
          },
          {
            label: '보호기기압력',
            align: 'center',
            child: [
              {
                name: 'protectSerial',
                field: 'protectSerial',
                label: '기기번호',
                align: 'center',
                sortable: true,
                style: 'width:80px',
              },
              {
                name: 'protectOperation',
                field: 'protectOperation',
                label: '운전(MPa)',
                align: 'center',
                sortable: true,
                style: 'width:60px',
              },
              {
                name: 'protectDesign',
                field: 'protectDesign',
                label: '설계(MPa)',
                align: 'center',
                sortable: true,
                style: 'width:60px',
              },
            ]
          },
          {
            label: '안전밸브 등',
            align: 'center',
            child: [
              {
                name: 'valveSetting',
                field: 'valveSetting',
                label: '설정(Mpa)',
                align: 'center',
                style: 'width:60px',
                sortable: true,
              },
              {
                name: 'safetyValveMaterial',
                field: 'safetyValveMaterial',
                label: '몸체재질',
                align: 'center',
                style: 'width:80px',
                sortable: true,
              },
              {
                name: 'safetyValveTrim',
                field: 'safetyValveTrim',
                label: 'Trim재질',
                align: 'center',
                style: 'width:80px',
                sortable: true,
              },
            ]
          },
          {
            name: 'precisionVal',
            field: 'precisionVal',
            label: '정밀도(오차범위)',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'outConnect',
            field: 'outConnect',
            label: '배출연결부위',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'outReason',
            field: 'outReason',
            label: '배출원인',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'formVal',
            field: 'formVal',
            label: '형식',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        valveRuptureNo: '',
        inMaterial: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.pfi.valve.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./safetyValveRuptureDiskDetail.vue"}`);
      this.popupOptions.title = '안전밸브 및 파열판 상세';
      this.popupOptions.param = {
        psiValveRuptureId: result ? result.psiValveRuptureId : '',
      };
      this.popupOptions.width = '100%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
